import { CheckCircleOutlineRounded } from "@mui/icons-material";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Typography,
} from "@mui/material";
import { black, greenLight, greyEnabled, purple, purpleLight } from "../../../../theme/colors";

interface Props {
  open: boolean;
  serviceName?: string;
  submitting?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function ApproveServicePopup({
  open,
  serviceName,
  submitting = false,
  onClose,
  onConfirm,
}: Props) {
  return (
    <Dialog open={open} onClose={() => !submitting && onClose()} PaperProps={{ sx: { borderRadius: 4 } }}>
      <DialogContent sx={{ width: 400, maxWidth: "90vw", p: 4, display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 56,
            height: 56,
            borderRadius: "50%",
            bgcolor: greenLight,
            mb: 2,
          }}
        >
          <CheckCircleOutlineRounded sx={{ color: "#1E6446", fontSize: 28 }} />
        </Box>
        <Typography variant="h6" fontWeight={700} color={black} textAlign="center">
          Approve this service?
        </Typography>
        <Typography variant="body2" color={greyEnabled} textAlign="center" mt={0.5}>
          {serviceName
            ? <>You're about to approve <strong>{serviceName}</strong>. It will become visible to users.</>
            : "It will become visible to users."}
        </Typography>

        <Box display="flex" gap={1.5} width="100%" mt={4}>
          <Button
            fullWidth
            disabled={submitting}
            onClick={onClose}
            variant="outlined"
            sx={{
              borderColor: purple,
              color: purple,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { borderColor: purple, bgcolor: purpleLight },
            }}
          >
            Cancel
          </Button>
          <Button
            fullWidth
            disabled={submitting}
            onClick={onConfirm}
            variant="contained"
            disableElevation
            startIcon={submitting ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : undefined}
            sx={{
              bgcolor: purple,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { bgcolor: "#7A2074" },
            }}
          >
            Approve
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
